import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Skeleton,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Settings } from '@mui/icons-material';
import { useGetApiV5FilesPreferredFormat } from 'api/v5/files/files';
import { AINamingFormatSettingsForm } from './components';

const FormatSettingsWrapper = styled(Box)({
  minHeight: '207px',
});

export const AINamingFormatSettings = () => {
  const [expanded, setExpanded] = useState(false);

  const { data: preferredFormat, isLoading: isLoadingPreferredFormat } =
    useGetApiV5FilesPreferredFormat({
      query: {
        cacheTime: 10 * 60 * 1000 * 6 /* 60 minutes */,
        staleTime: 10 * 60 * 1000 * 6 /* 60 minutes */,
        retry: false,
      },
    });

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded((currentStatus) => !currentStatus)}
      elevation={0}
      square
      disableGutters
      sx={{
        border: 'none',
        borderBottom: 'none',
        boxShadow: 'none',
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="ai-file-management-content"
        id="ai-file-management-header"
        sx={{
          padding: 0,
          minHeight: 'auto',
          borderBottom: 'none',
          '&.MuiButtonBase-root-MuiAccordionSummary-root': {
            borderBottom: 'none',
          },
        }}
      >
        <Stack aria-label="Manage file name" sx={{ width: '90%' }}>
          <Box
            className="form-group form-inline-label"
            mb={0}
            flex={1}
            display="flex"
          >
            <Stack direction="row" gap={2} alignItems="center">
              <Settings />
              <Typography variant="body1" fontWeight={600}>
                Preferred Naming Format
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: 0,
        }}
      >
        <FormatSettingsWrapper>
          {isLoadingPreferredFormat && <Skeleton height={207} />}
          {!isLoadingPreferredFormat && (
            <AINamingFormatSettingsForm
              preferredFormat={preferredFormat?.format || ''}
            />
          )}
        </FormatSettingsWrapper>
      </AccordionDetails>
    </Accordion>
  );
};
